module.exports = __webpack_public_path__ + "media/images/icon/icons8-Answers-cf658534494c28701791254e56082b25.png";